import React from 'react';
import { Row, Col } from 'src/componentes/grid';
import FarolAcaoLookup from '../../lookups/farol-acao';

class AreaColaboradorSearch extends React.Component {
  render() {
    let { model } = this.props;

    return (
      <div>
        <Row>
          <Col md={3}>
            <FarolAcaoLookup clearable model={model.getModel('farol')} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default AreaColaboradorSearch;
